import { render } from "./DebtLossInvoicesTable.vue?vue&type=template&id=3843be1e"
import script from "./DebtLossInvoicesTable.vue?vue&type=script&lang=js"
export * from "./DebtLossInvoicesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__